import * as React from 'react'
import {
  Route,
  RouteComponentProps,
  Switch,
  withRouter,
} from 'react-router-dom'

import { Vehicles } from '../Calculator/Vehicles'
import { Policy } from '../Contract/Policy'
import { DateDuration } from './DateDuration'
import { PolicyholderData } from './PolicyholderData'

export class ContractLayout extends React.Component<RouteComponentProps<any>> {
  render() {
    const { match } = this.props
    return (
      <>
        <Switch>
          <Route path={`${match.path}/duration`} component={DateDuration} />
          <Route
            path={`${match.path}/policyholder`}
            component={PolicyholderData}
          />
          <Route path={`${match.path}/policy-summary`} component={Policy} />
        </Switch>
      </>
    )
  }
}

export const Contract = withRouter(ContractLayout)
